import { apiCall } from "./servicesCall";

export const EMBED_SERVICES = {
  embed(data) {
    return apiCall("/embed", data);
  },
};
